import React from 'react';
import { Button } from './primitives';

type SimButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

type SimButtonProps = {
  children: React.ReactNode;
  variant?: SimButtonVariant;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  className?: string;
};

const SimButton: React.FC<SimButtonProps> = ({
  children,
  variant = 'primary',
  disabled = false,
  type = 'button',
  onClick,
  className = '',
}) => {
  return (
    <Button type={type} onClick={onClick} disabled={disabled} variant={variant} className={className}>
      {children}
    </Button>
  );
};

export default SimButton;
